<template>
  <div class="list-view">
    <div
      v-if="filteredEvents.length === 0"
      class="empty-state"
    >
      Nenhum agendamento encontrado no período.
    </div>
    <div
      v-else
      class="event-list"
    >
      <div
        v-for="event in sortedEvents"
        :key="event.id"
        class="event-card"
        @click="$emit('eventClick', event)"
      >
        <div
          class="event-color-bar"
          :style="{ backgroundColor: getStatusColor(event.status) }"
        />
        <div class="event-info">
          <div class="event-cliente">
            Cliente: {{ formatCliente(event.cliente) }}
          </div>
          <div class="event-badges">
            <span
              class="badge"
              :class="getStatusBadgeClass(event.status)"
            >
              {{ getStatusLabel(event.status) }}
            </span>
            <span
              v-if="event.motivo"
              class="badge ml-1"
              :class="getMotivoBadgeClass(event.motivo)"
            >
              {{ getMotivoLabel(event.motivo) }}
            </span>
          </div>
        </div>
        <div class="event-meta">
          <div class="event-date">
            {{ formatDateTime(event.data_agendamento) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStatusColor, getStatusBadgeClass, getStatusLabel, getMotivoBadgeClass, getMotivoLabel, formatCliente, formatDateTime } from '../calendar-utils'

export default {
  name: 'CalendarListView',
  props: {
    filteredEvents: { type: Array, required: true },
    sortedEvents: { type: Array, required: true },
  },
  methods: {
    getStatusColor,
    getStatusBadgeClass,
    getStatusLabel,
    getMotivoBadgeClass,
    getMotivoLabel,
    formatCliente,
    formatDateTime,
  },
}
</script>

<style scoped>
.list-view {
  background: #fff;
  min-height: 500px;
  padding: 16px;
}

.empty-state {
  padding: 32px 0;
  text-align: center;
  color: #70757a;
}

.event-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.event-card {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  border: 1px solid #dadce0;
  border-radius: 16px;
  background: #fff;
  padding: 12px;
  transition: background-color 0.15s;
}

.event-card:hover {
  background: #f8fafd;
}

.event-color-bar {
  width: 4px;
  height: 48px;
  border-radius: 9999px;
  flex-shrink: 0;
}

.event-info {
  flex: 1;
  min-width: 0;
}

.event-cliente {
  font-weight: 400;
  color: #202124;
}

.event-badges {
  margin-top: 4px;
}

.event-meta {
  text-align: right;
  flex-shrink: 0;
}

.event-date {
  font-size: 13px;
  font-weight: 400;
  color: #3c4043;
}

.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-top: 4px;
}

.badge-info { background: #e8f0fe; color: #1967d2; }
.badge-warning { background: #fef7e0; color: #b06000; }
.badge-success { background: #e6f4ea; color: #137333; }
.badge-danger { background: #fce8e6; color: #c5221f; }
.badge-primary { background: #e8e0f4; color: #6929a8; }
.badge-secondary { background: #f1f3f4; color: #5f6368; }
</style>
